module.exports = __webpack_public_path__ + "static/img/image_support_article_details_p4.6b864de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_article_details_p4.png
// module id = UyKF
// module chunks = 10